/*
 * Javascript for the home page
 */
import { getUrlParameter, isValidPostcode, sendEvent } from "./global.js";


var renderMap,
	xhr,
	global_markers = [],
	global_markers_data = [],
	newlistings = [],
	search_url,
	search_query,
	centerCoords,
	zoomLevel,
	previousCenterCoords,
	previousZoomLevel,
	markerCluster,
	infowindows = [],
	infowindow,
	newmarkers,
	latitude,
	longitude,
	actual_latitude,
	actual_longitude,
	listing_html;
let map;

(function ($) {
	if ($("body.find-a-church").length) {
		jQuery(function ($) {});

		async function initMap() {
			const { Map } = await google.maps.importLibrary("maps");
			const { AdvancedMarkerElement } = await google.maps.importLibrary(
				"marker"
			);

			var url_lat = parseFloat(getUrlParameter("search_lat"));
			var url_lon = parseFloat(getUrlParameter("search_lon"));
			var url_place = decodeURIComponent(getUrlParameter("search_place"));
			var url_name = decodeURIComponent(getUrlParameter("search_name"));

			var map_center = {
				lat: 53.76293458756777,
				lng: -2.1087462927010394,
			};
			if (url_lat && url_lon) {
				var map_center = { lat: url_lat, lng: url_lon };
				search_lat_lon(url_lat, url_lon);
				reverseGeocode(url_lat, url_lon);
			} else if (url_place !== "undefined") {
				search_place(url_place);
				$("#search_place").val(url_place);
			} else if (url_name !== "undefined") {
				search_name(url_name);
				$("#search_name").val(url_name);
			} else {
				search_all();
			}

			var pinSVGHole =
				"M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";

			var search_icon = {
					path: pinSVGHole,
					anchor: new google.maps.Point(12, 17),
					fillOpacity: 1,
					fillColor: "#2bb2bc",
					strokeWeight: 1,
					strokeColor: "#1c9da0",
					scale: 2,
				},
				search_icon_hover = {
					path: pinSVGHole,
					anchor: new google.maps.Point(12, 17),
					fillOpacity: 1,
					fillColor: "#3c4981",
					strokeWeight: 1,
					strokeColor: "#2e3d6b",
					scale: 2,
				};

			var search_map = $("#map"),
				map_zoom = 6,
				search_query = null,
				// Search results records
				stats = {
					churches: 0,
					schools: 0,
				},
				search_max_key,
				search_selected,
				search_data;

			map = new Map(document.getElementById("map"), {
				center: map_center,
				zoom: map_zoom,
				mapId: "10c54dda61bbc61b",
			});

			previousZoomLevel = map_zoom;
			zoomLevel = map_zoom;
			previousCenterCoords = map_center;
			centerCoords = map_center;

			map.addListener("center_changed", function () {
				centerCoords = map.getCenter();
			});

			map.addListener("zoom_changed", function () {
				zoomLevel = map.getZoom();
			});

			//Placeholder autocomplete
			var input = document.getElementById("search_place");
			var autocomplete = new google.maps.places.Autocomplete(input);

			// Set initial restrict to the greater list of countries.
			autocomplete.setComponentRestrictions({ country: ["gb"] });

			autocomplete.addListener("place_changed", function () {
				var place = autocomplete.getPlace();
				if (place.geometry) {
					search_query = place.name;
					var lat = place.geometry.location.lat(),
						lng = place.geometry.location.lng();
					search_lat_lon(lat, lng);
					map.setCenter(place.geometry.location);
				}
			});

			function searchLoader(option) {
				if (option == "start") {
					$(".church-finder-map-container").addClass("searching");
					$(".animated-loading-bar").removeClass("hidden");
				} else if (option == "end") {
					$(".church-finder-map-container").removeClass("searching");
					$(".animated-loading-bar").addClass("hidden");
				}
			}

			//The three searches
			//Search by Name // Search by Place // Search by Lat/Lon
			function search_name(name) {
				if (name) {
					name = name.replace(/\+/g, " ");
					search_url = "?search_name=" + encodeURIComponent(name);
					if (xhr && xhr.readyState != 4) {
						xhr.abort();
					}
					xhr = $.ajax({
						type: "GET",
						url: "/actions/church-search/search/search-name",
						dataType: "json",
						data: {
							name: name,
						},
						traditional: true,
						beforeSend: function () {
							searchLoader("start");
							//Analytics
							if (!$("body").hasClass("devmode-true")) {
								//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
								sendEvent(
									"event",
									undefined,
									"church_search",
									"name",
									encodeURIComponent(name),
									true
								);
							}
						},
						success: function (data) {
							process_search(data, "name");
							searchLoader("end");
						},
					});
				}
			}
			function search_place(place) {
				if (place) {
					search_url = "?search_place=" + encodeURIComponent(place);
					if (xhr && xhr.readyState != 4) {
						xhr.abort();
					}
					xhr = $.ajax({
						type: "GET",
						url: "/actions/church-search/search/search-place",
						dataType: "json",
						data: {
							place: place,
						},
						traditional: true,
						beforeSend: function () {
							searchLoader("start");
							//Analytics
							if (!$("body").hasClass("devmode-true")) {
								//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
								sendEvent(
									"event",
									undefined,
									"church_search",
									"place",
									encodeURIComponent(place),
									true
								);
							}
						},
						success: function (data) {
							process_search(data, "place");
							searchLoader("end");
						},
					});
				}
			}
			function search_lat_lon(lat, lon) {
				if (lat && lon) {
					search_url =
						"?search_lat=" +
						encodeURIComponent(lat) +
						"&search_lon=" +
						encodeURIComponent(lon);
					if (xhr && xhr.readyState != 4) {
						xhr.abort();
					}
					xhr = $.ajax({
						type: "GET",
						url: "/actions/church-search/search/search-location",
						dataType: "json",
						data: {
							lat: lat,
							lon: lon,
						},
						traditional: true,
						beforeSend: function () {
							searchLoader("start");
							//Analytics
							if (!$("body").hasClass("devmode-true")) {
								//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
								sendEvent(
									"event",
									undefined,
									"church_search",
									"latlon",
									encodeURIComponent(lat + "," + lon),
									true
								);
							}
						},
						success: function (data) {
							process_search(data, "place");
							searchLoader("end");
						},
					});
				}
			}

			function search_all() {
				$(".map-container").removeClass("sm:w-8/12");
				$(".search-sidebar").addClass("hidden");
				$("#search_name").val("");
				$("#search_place").val("");

				search_url = "";
				if (xhr && xhr.readyState != 4) {
					xhr.abort();
				}
				xhr = $.ajax({
					type: "GET",
					url: "/actions/church-search/search/search-all",
					dataType: "json",
					traditional: true,
					beforeSend: function () {
						searchLoader("start");
						//Analytics
						if (!$("body").hasClass("devmode-true")) {
							//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
							//sendEvent('event', undefined, 'church_search', 'latlon', encodeURIComponent(lat+','+lon), true);
						}
					},
					success: function (data) {
						process_search(data, "all");
						searchLoader("end");
					},
				});
			}

			//The search
			function process_search(data, type) {
				if (data && type) {
					//Update URL
					window.history.replaceState(
						{},
						document.title,
						"/churches" + search_url
					);

					if (data.length == 0) {
						$(".church-finder-map-container").addClass("hidden");
						$(".no-results").removeClass("hidden");
					} else {
						$(".church-finder-map-container").removeClass("hidden");
						$(".no-results").addClass("hidden");

						newmarkers = [];
						newlistings = [];

						$.each(data, function (i, val) {
							// Add custom markers for pins
							if (
								val.actual_latitude | length &&
								val.actual_longitude
							) {
								latitude = val.actual_latitude;
								longitude = val.actual_longitude;
							} else {
								latitude = val.latitude;
								longitude = val.longitude;
							}

							var position = new google.maps.LatLng(
								latitude,
								longitude
							);
							
							newmarkers.push({
								lat: latitude,
								lng: longitude,
								name: val.name,
								membership_num: val.membershipID,
								church_slug: val.slug,
							});

							//Data for the sidebar
							//console.log(val);
							val.address =
								(val.address1 ? val.address1 + ", " : "") +
								(val.address2 ? val.address2 + ", " : "") +
								(val.address3 ? val.address3 + ", " : "") +
								(val.town ? val.town + ", " : "") +
								(val.county ? val.county + ", " : "") +
								(val.postcode ? val.postcode : "");

							//console.log(val.address);

							newlistings.push(val);
							/*
							marker.setMap(map);*/
						});

						if (type != "all") {
							updateSidebar(newlistings);
						}
						updateMarkers(newmarkers);

						if (type != "all") {
							var target = $(".church-finder-map-container");
							var offset = target.offset().top;
							$("html, body").animate(
								{
									scrollTop: offset,
								},
								1000
							);
						}
					}
				}
			}

			//Select sidebar church
			$(document).on("click", ".results .church", function () {
				$(".extra-details").addClass("hidden");
				$(".results .church")
					.removeClass("bg-site-index")
					.addClass("hover:bg-site-index");
				$(".results .church .number")
					.addClass("text-primary-200")
					.removeClass("text-primary-100");
				$(".results .church .more-details").removeClass("rotate-180");
				if ($(this).hasClass("expanded")) {
					map.setCenter(previousCenterCoords);
					map.setZoom(previousZoomLevel);
					resetMarkers();
					$(this).removeClass("expanded");
				} else {
					$(this)
						.addClass("bg-site-index")
						.removeClass("hover:bg-site-index");
					$(this).find(".more-details").addClass("rotate-180");
					$(this)
						.find(".number")
						.removeClass("text-primary-200")
						.addClass("text-primary-100");
					$(this).find(".extra-details").removeClass("hidden");
					//church_id = $(this).attr('data-church-id');
					var membership_num = $(this).attr("data-membership-num");
					var marker_id = $(this).attr("data-marker-id");
					var marker = global_markers_data[marker_id].marker;

					expandChurch(membership_num, marker, false);
				}
			});

			/*$(document).on("mouseenter", ".results .church", function() {
				marker_id = $(this).attr('data-marker-id');
				var marker = global_markers[marker_id];
				resetMarkers();
				marker.setIcon(search_icon_hover);
				marker.setZIndex(50);
			});
			$(document).on("mouseleave", ".church-listing", function() {
				if ($(this).hasClass('selected')) {} else {
					resetMarkers();
				}
			});*/

			//Select Marker
			function resetMarkers() {
				for (var i = 0; i < global_markers_data.length; i++) {
					global_markers_data[i].marker.setZIndex(1);
					global_markers_data[i].marker.setIcon(search_icon);
				}
			}

			//Select Marker
			function highlightMarker(marker) {
				if (typeof marker.marker !== "undefined") {
					marker = marker.marker;
				}

				if (infowindow) {
					infowindow.close(); // Close the previously open InfoWindow
				}

				var position = marker.position;

				for (var i = 0; i < global_markers_data.length; i++) {
					global_markers_data[i].marker.setZIndex(1);
					global_markers_data[i].marker.setIcon(search_icon);
				}

				marker.setIcon(search_icon_hover);
				marker.setZIndex(50);

				previousCenterCoords = centerCoords;
				previousZoomLevel = zoomLevel;

				map.setZoom(14);
				map.setCenter(position);
			}

			function isValidHttpUrl(string) {
				try {
					const url = new URL(string);
					return (
						url.protocol === "http:" || url.protocol === "https:"
					);
				} catch (err) {
					return false;
				}
			}

			function updateSidebar(newlistings) {
				if (newlistings) {
					//Reveal sidebar
					$(".map-container").addClass("sm:w-8/12");
					$(".search-sidebar").removeClass("hidden");

					var results_container = $(".results");
					results_container.empty();
					$.each(newlistings, function (i, val) {
						//console.log(val);
						listing_html = $(".sidebar-template").html();
						listing_html = listing_html.replace("[marker_id]", i);
						listing_html = listing_html.replace("[number]", i + 1);
						listing_html = listing_html.replace(
							"[name]",
							val.name
						);
						listing_html = listing_html.replace(
							"[address]",
							val.address
						);
						listing_html = listing_html.replace(
							"[membership_num]",
							val.membershipID
						);

						//HTTP Link
						var prefix = "http://";
						if (isValidHttpUrl(val.website)) {
							var http_link = val.website;
						} else {
							var http_link = prefix + val.website;
						}

						//Expanded details
						listing_html = listing_html.replace(
							"[extra_mem_num]",
							"<strong>Membership number:</strong> " +
								val.membershipID +
								"<br />"
						);
						listing_html = listing_html.replace(
							"[go_to_profile]",
							'<br /><a class="font-bold" href="/churches/' +
								val.slug +
								'">Go to church profile ></a><br />'
						);
						if (val.denomination) {
							listing_html = listing_html.replace(
								"[extra_denomination]",
								"<strong>Denomination:</strong> " +
									val.denomination +
									"<br />"
							);
						} else {
							listing_html = listing_html.replace(
								"[extra_denomination]",
								""
							);
						}
						if (val.website) {
							listing_html = listing_html.replace(
								"[extra_website]",
								'<strong>Website:</strong> <a href="' +
									http_link +
									'" target="_blank">' +
									val.website +
									"</a><br />"
							);
						} else {
							listing_html = listing_html.replace(
								"[extra_website]",
								""
							);
						}
						if (val.phone) {
							listing_html = listing_html.replace(
								"[extra_tel]",
								"<strong>Telephone:</strong> " +
									val.phone +
									"<br />"
							);
						} else {
							listing_html = listing_html.replace(
								"[extra_tel]",
								""
							);
						}

						if (val.distance) {
							distance_html = parseFloat(val.distance);

							var distance =
								'<span class="absolute bottom-0 right-0 text-right pb-1 w-1/3"><i class="far fa-map-signs mr-1"></i>' +
								distance_html.toFixed(2) +
								" miles</span>";
						} else {
							var distance = "";
						}
						listing_html = listing_html.replace(
							"[distance]",
							distance
						);
						results_container.append(listing_html);
					});
				}
			}
			function setMarkers(markers) {
				global_markers = [];
				global_markers_data = [];
				global_markers = markers.map((position, i) => {
					var mem_number = position.membership_num;
					var position = new google.maps.LatLng(
						position.lat,
						position.lng
					);

					var number = i + 1;
					var church = newlistings[i];

					var contentString =
						'<div id="content" class="font-sans-primary">' +
						'<h1 id="firstHeading" class="font-bold font-sans-secondary text-primary-400 border-b-3 text-lg sm:text-2xl">' +
						church.name +
						"</h1>" +
						'<div id="bodyContent" class="text-sm"><p>';

					if (church.address != null) {
						contentString +=
							'<i class="far fa-map-marked-alt text-primary-400 mr-2 mt-2"></i> ' +
							church.address +
							"" +
							"<br>";
					}
					if (church.membershipID != null) {
						contentString +=
							'<i class="far fa-id-card text-primary-400 mr-2 mt-2"></i> ' +
							church.membershipID +
							"" +
							"<br>";
					}
					if (church.website != null) {
						//HTTP Link
						var prefix = "http://";
						if (isValidHttpUrl(church.website)) {
							var http_link = church.website;
						} else {
							var http_link = prefix + church.website;
						}

						contentString +=
							'<i class="fas fa-globe  text-primary-400 mr-2 mt-2"></i><a href="' +
							http_link +
							'">' +
							church.website +
							"</a><br>";
					}
					if (church.phone != null) {
						contentString +=
							'<i class="far fa-phone text-primary-400 mr-2 mt-2"></i>' +
							church.phone +
							"" +
							"<br>";
					}
					if (church.denomination != null) {
						contentString +=
							'<i class="far fa-church text-primary-400 mr-2 mt-2"></i>' +
							church.denomination;
					}
					contentString +=
						"</p>" +
						'<p class="my-2 text-right w-full font-bold"><a href="/churches/' +
						church.slug +
						'">Go to church profile ></a></p>' +
						"</div>" +
						"</div>";

					const infowindow = new google.maps.InfoWindow({
						content: contentString,
					});

					infowindows.push(infowindow);

					const marker = new google.maps.Marker({
						position,
						icon: search_icon,
					});

					global_markers_data[i] = {
						position,
						mem_number,
						marker,
					};

					// markers can only be keyboard focusable when they have click listeners
					// open info window when marker is clicked
					marker.addListener("click", () => {
						//Loop through infowindows and close all infowindows
						for (var i = 0; i < infowindows.length; i++) {
							infowindows[i].close();
						}

						for (var i = 0; i < global_markers_data.length; i++) {
							global_markers_data[i].marker.setZIndex(1);
							global_markers_data[i].marker.setIcon(search_icon);
						}

						infowindow.open({
							anchor: marker,
							map,
						});

						highlightMarker(marker);

						$(".results .church").removeClass("selected expanded");

						//expandChurch(global_markers_data[i].mem_number, global_markers_data[i].marker, true);
					});

					// Event listener for closing the InfoWindow
					infowindow.addListener("closeclick", function () {
						// Reset the map to previous centerCoords and zoomLevel
						map.setCenter(previousCenterCoords);
						map.setZoom(previousZoomLevel);

						for (var i = 0; i < global_markers_data.length; i++) {
							global_markers_data[i].marker.setZIndex(1);
							global_markers_data[i].marker.setIcon(search_icon);
						}
					});

					return marker;
				});

				/*for (var i = 0; i < loop; i++) {
					var marker = markers[i];
					var position = new google.maps.LatLng(marker['latitude'], marker['longitude']);

					var marker = new AdvancedMarkerElement({
						position: position
					});
					//marker.setMap(map);

					// Push marker to markers array
					global_markers.push(marker);

					/*google.maps.event.addListener(marker, 'click', function () {
						//setCurrentMapBounds();
						//console.log(this);
						//church_id = this.church_id;
						var marker = this;
						expandChurch(marker.membership_num,marker,true);
						//$(this).addClass('selected');
						//map.panBy(-400,100);
					});*/
				/*}*/
			}

			function expandChurch(membership_num, marker, from_marker) {
				highlightMarker(marker);
				$(".results .church").removeClass("selected expanded");
				var church_container = $(
					'.results .church[data-membership-num="' +
						membership_num +
						'"]'
				);
				church_container.addClass("selected expanded");
				if (from_marker) {
					var parent_div = $(".search-sidebar");
					parent_div.scrollTop(
						parent_div.scrollTop() + church_container.position().top
					);
				}

				scrollToMap();
			}

			function updateMarkers(markers) {
				// Loop through markers and set map to null for each
				removeMarkers();

				// Call set markers to re-add markers
				setMarkers(markers, false);

				const svg = window.btoa(`
				<svg fill="#2bb2bc" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
				<circle cx="120" cy="120" opacity="1" r="70" />
				<circle cx="120" cy="120" opacity=".7" r="90" />
				<circle cx="120" cy="120" opacity=".3" r="110" />
				<circle cx="120" cy="120" opacity=".2" r="130" />
				</svg>`);

				const renderer = {
					render: ({ count, position }) =>
						new google.maps.Marker({
							label: {
								text: String(count),
								color: "#fff",
								fontFamily: "proxima-nova, sans-serif",
								fontSize: "13px",
								fontWeight: "600",
							},
							icon: {
								url: `data:image/svg+xml;base64,${svg}`,
								scaledSize: new google.maps.Size(45, 45),
							},
							position,
							// adjust zIndex to be above other markers
							zIndex:
								Number(google.maps.Marker.MAX_ZINDEX) + count,
						}),
				};

				markerCluster = new markerClusterer.MarkerClusterer({
					markers: global_markers,
					map: map,
					renderer: renderer,
				});

				//THIS WORKS - BUT DOESN'T HAVE 'SMOOTH ZOOM'
				var bounds = global_markers.reduce(function (bounds, marker) {
					return bounds.extend(marker.getPosition());
				}, new google.maps.LatLngBounds());

				map.setCenter(bounds.getCenter());
				if (markers.length > 1) {
					map.fitBounds(bounds);
				} else if (markers.length == 1) {
					var marker = global_markers[0];
					var membership_num = markers[0].membership_num;
					expandChurch(membership_num, marker, false);
				}
				//setCurrentMapBounds();
			}

			function removeMarkers() {
				if (markerCluster) {
					markerCluster.clearMarkers();
				}

				for (var i = 0; i < global_markers.length; i++) {
					global_markers[i].setMap(null);
				}
				global_markers_data = [];
				global_markers = [];
			}

			//URL Functions
			function updateUrlParams(church_id, lat, lon, zoom) {
				//console.log('updateUrlParams('+church_id+','+lat+','+lon+','+zoom+')');
				//window.history.pushState('tmp', 'new-url', '/find-a-church/'+church_id+','+lat+','+lon+','+zoom);
				//History.pushState({state:'tmp'}, 'easilyfound.it | Church Search', '/find-a-church/'+church_id+','+lat+','+lon+','+zoom);
			}

			//This just checks the URL parameters to see if we have a search
			//The Lat/Lon/Zoom is processed by renderMap
			function checkUrlParams() {}

			//Scroll to map
			function scrollToMap() {
				var target = $(".church-finder-map-container");
				var offset = target.offset().top;
				$("html, body").animate(
					{
						scrollTop: offset,
					},
					1000
				);
			}

			//Search Binding
			$("#search_name").bind(
				"propertychange change keyup input paste",
				function (event) {
					$("#search_place").val("");
				}
			);
			$("#search_place").bind(
				"propertychange change keyup input paste",
				function (event) {
					$("#search_name").val("");
				}
			);

			$("#church-search-submit").on("click", function (e) {
				if (
					$("#search_name").val() == "" &&
					$("#search_place").val() == ""
				) {
					search_all();
				} else if ($("#search_name").val() != "") {
					$("#church-search-name").submit();
				} else if ($("#search_place").val() != "") {
					$("#church-search-place").submit();
				}
			});

			$(".view-all-churches").on("click", function (e) {
				e.preventDefault();
				search_all();

				scrollToMap();
			});

			$(".church-search-form").on("submit", function (e) {
				//use on if jQuery 1.7+
				e.preventDefault();
				input = $(this).find('input[type="text"]');
				var search_query = input.val();
				var search_type = input.data("search-type");
				if (xhr && xhr.readyState != 4) {
					xhr.abort();
				}

				var target = $(".church-finder-map-container");
				var offset = target.offset().top;
				$("html, body").animate(
					{
						scrollTop: offset,
					},
					1000
				);

				if (search_query.length == 0) {
					search_all();
				} else if (search_query.length > 2) {
					// If value has changed...
					if (input.data("oldVal") != input.val()) {
						if (xhr && xhr.readyState != 4) {
							xhr.abort();
						}
						if (search_type == "name") {
							$("#search_place").val("");
							if (isValidPostcode(search_query)) {
								$("#search_name").val("");
								$("#search_place").val(search_query);
								//Oh no - the user has entered their postcode in the 'Name' field
								search_place(search_query);
							} else {
								$("#search_place").val("");
								search_name(search_query);
							}
						} else if (search_type == "place") {
							$("#search_name").val("");
							search_place(search_query);
						}
					}
				}
				if (input.val() == "") {
					if (event.keyCode != 8) {
						//keyCode 8 = backspace - don't search
						//getAllMarkersUpdate();
					}
				}
				return false;
			});

			$(document).ready(function (e) {
				//Geolocation stuff
				if (navigator.geolocation) {
					$(".input.place").addClass("geolocation");
					$(document).on("click", ".get-location", function (e) {
						navigator.geolocation.getCurrentPosition(
							function (position) {
								//Add 'Your Location' marker
								var marker = new google.maps.Marker({
									position: new google.maps.LatLng(position.coords.latitude, position.coords.longitude),
									draggable: false,
									icon: {
										path: google.maps.SymbolPath.CIRCLE,
										fillColor: "#459bea",
										fillOpacity: 1,
										scale: 11,
										strokeWeight: 0,
									},
								});
								marker.setMap(map);

								search_lat_lon(position.coords.latitude, position.coords.longitude);

								reverseGeocode(position.coords.latitude, position.coords.longitude);
							},
							function () {
								alert("There was a problem finding your location");
								console.error("Error getting your location");
								console.info("Might be on a non-https URL");
							}
						);
					});
				}
			});

			//Get location name (Reverse GeoCode)
			function reverseGeocode(lat, lon) {
				var geocoder = new google.maps.Geocoder();
				var latlng = { lat: lat, lng: lon };
				geocoder.geocode({ location: latlng }, function (
					results,
					status
				) {
					if (status === "OK") {
						if (results[0]) {
							$("#search_place").val(
								results[0].formatted_address
							);
						}
					}
				});
			}
			/*if (search_parish !== 'None') {
				//map.data.loadGeoJson(search_parish);

				map.data.setStyle({
					fillColor: '#E8A065',
					strokeColor: '#E8A065',
					strokeWeight: 3
				});
			}*/

			// Custom marker (JS LINTER IGNORES THIS SECTION)
			/* jshint ignore:start */

			/* jshint ignore:end */
		}

		initMap();
	}
})(jQuery);

//Polyfill for .find - not supported on IE
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, "find", {
		value: function (predicate) {
			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== "function") {
				throw new TypeError("predicate must be a function");
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		},
	});
}
